/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "arrow-upright-674b120c--sprite",
  "use": "arrow-upright-674b120c--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"arrow-upright-674b120c--sprite\"><g transform=\"translate(-8897.973 -745)\"><g transform=\"translate(8898 745)\" fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g><circle cx=\"18\" cy=\"18\" r=\"18\" transform=\"translate(0 0.008)\" fill=\"#eceade\" opacity=\"0\" /><rect width=\"36\" height=\"36\" transform=\"translate(0.027)\" fill=\"none\" /><g transform=\"translate(8.923 18.133) rotate(-45)\"><path d=\"M0,15.451V0\" transform=\"translate(14.185 5.854) rotate(90)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" /><path d=\"M8.3,0V8.3H0\" transform=\"translate(2.593 5.869) rotate(-45)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
